// AlertSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showAlert: false,
  alertMessage: '',
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    setAlert: (state, action) => {
      state.showAlert = true;
      state.alertMessage = action.payload;
    },
    clearAlert: (state) => {
      state.showAlert = false;
      state.alertMessage = '';
    },
  },
});

export const { setAlert, clearAlert } = alertSlice.actions;
export default alertSlice.reducer;